<template>
  <v-container fluid>
    <v-tabs v-model="selectedTab" slider-color="#E07353">
      <v-tab>ХИЧЭЭЛЭЭР</v-tab>
      <v-tab>СУРАЛЦАГЧААР </v-tab>
      <v-tab>НЭГТГЭЛ</v-tab>
      <v-tab>ХИЧЭЭЛИЙН ДҮН ТАТАХ</v-tab>
    </v-tabs>
    <v-select
      class="mx-2 mt-10"
      :items="[12, 11, 10]"
      label="Анги сонгоx"
      style="width: 30%"
      v-model="selectedLevel"
      :disabled="lockedToCurrentLevel"
    >
    </v-select>
    <v-tabs-items v-model="selectedTab">
      <v-tab-item>
        <v-data-table
          v-if="finalCourses && renderComponent"
          :headers="headers"
          :items="finalCourses"
          class="elevation-1"
          dense
          hide-details
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Хичээл</v-toolbar-title>
            </v-toolbar>
          </template>
        </v-data-table></v-tab-item
      >
      <v-tab-item>
        <h3 class="mx-4 py-4">Суралцагчийн мэдээлэл</h3>
        <v-data-table
          v-if="renderComponent"
          :headers="headers2"
          :items="students"
          hide-default-footer
          :items-per-page="-1"
        >
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <v-data-table
          v-if="grades && renderComponent"
          :headers="headers3"
          :items="students"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title> Нэгтгэл </v-toolbar-title>
            </v-toolbar>
          </template>
          <template v-slot:item.numberOfElectives="{ item }">
            {{ getNumberOfElectives(item) }}
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item
        >4
        <v-btn outlined> Xичээл татаx </v-btn>
        <v-btn class="mt-4 bg-gradient-success" dark> Дүн оруулаx </v-btn>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
const fb = require("@/firebaseConfig.js");
export default {
  data() {
    return {
      selectedLevel: 12,
      selectedTab: 0,
      headers: [
        { text: "No", value: "index", align: "start" },
        { text: "Хичээл", value: "COURSE_NAME" },
        // { text: "Төрөл", value: "type" },
        { text: "Нийт судалсан", value: "TOTAL" },
        { text: "Дүн батлагдсан", value: "APPROVED" },
        { text: "Дүн бүртгэсэн", value: "REGISTERED" },
        { text: "Хянагдаж байгаа", value: "IN_PROGRESS" },
        { text: "Дүн цуцлагдсан", value: "REJECTED" },
      ],
      courses: [
        {
          name: "Монгол хэл 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Үндэсний бичиг 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Уран зохиол 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Математик 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Мэдээллийн технологи 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Англи хэл 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Орос хэл 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Биеийн тамир 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Эрүүл мэнд 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Дизайн/зураг зүй, технологи 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
      ],

      headers2: [
        { text: "Суралцагч", value: "name", align: "start" },
        { text: "Регистр", value: "REGISTER" },
        { text: "Нийт судалсан", value: "TOTAL" },
        { text: "Дүн батлагдсан", value: "APPROVED" },
        { text: "Дүн бүртгэсэн", value: "REGISTERED" },
        { text: "Xянагдаж байгаа", value: "IN_PROGRESS" },
        { text: "Дүн цуцлагдсан", value: "REJECTED" },
      ],
      // students: [
      //   {
      //     student: "Н.Бархасвад",
      //     register: "ме07322714",
      //     totalStudied: 91,
      //     calculated1: 0,
      //     notCalculated1: 17,
      //     calculated2: 0,
      //     notCalculated2: 38,
      //     calculated3: 0,
      //     notCalculated3: 17,
      //   },
      //   {
      //     student: "М.Ванчир-Эрдэнэ",
      //     register: "ме07241811",
      //     totalStudied: 91,
      //     calculated1: 0,
      //     notCalculated1: 17,
      //     calculated2: 0,
      //     notCalculated2: 38,
      //     calculated3: 0,
      //     notCalculated3: 17,
      //   },
      //   {
      //     student: "Б.Гансух",
      //     register: "ру07272316",
      //     totalStudied: 91,
      //     calculated1: 0,
      //     notCalculated1: 17,
      //     calculated2: 0,
      //     notCalculated2: 38,
      //     calculated3: 0,
      //     notCalculated3: 17,
      //   },
      //   {
      //     student: "У.Жавхлан",
      //     register: "тя07252311",
      //     totalStudied: 91,
      //     calculated1: 0,
      //     notCalculated1: 17,
      //     calculated2: 0,
      //     notCalculated2: 38,
      //     calculated3: 0,
      //     notCalculated3: 17,
      //   },
      //   {
      //     student: "Э.Мичидмаа",
      //     register: "ме07231700",
      //     totalStudied: 91,
      //     calculated1: 0,
      //     notCalculated1: 17,
      //     calculated2: 0,
      //     notCalculated2: 38,
      //     calculated3: 0,
      //     notCalculated3: 17,
      //   },
      //   {
      //     student: "Д.Мягмарсүх",
      //     register: "ме07280709",
      //     totalStudied: 91,
      //     calculated1: 0,
      //     notCalculated1: 17,
      //     calculated2: 0,
      //     notCalculated2: 38,
      //     calculated3: 0,
      //     notCalculated3: 17,
      //   },
      //   {
      //     student: "Т.Мөнхтулга",
      //     register: "ме07312717",
      //     totalStudied: 91,
      //     calculated1: 0,
      //     notCalculated1: 17,
      //     calculated2: 0,
      //     notCalculated2: 38,
      //     calculated3: 0,
      //     notCalculated3: 17,
      //   },
      //   {
      //     student: "Б.Мөнхцэцэг",
      //     register: "ме07292605",
      //     totalStudied: 91,
      //     calculated1: 0,
      //     notCalculated1: 17,
      //     calculated2: 0,
      //     notCalculated2: 38,
      //     calculated3: 0,
      //     notCalculated3: 17,
      //   },
      //   {
      //     student: "Н.Мөрөн",
      //     register: "ме07292514",
      //     totalStudied: 91,
      //     calculated1: 0,
      //     notCalculated1: 17,
      //     calculated2: 0,
      //     notCalculated2: 38,
      //     calculated3: 0,
      //     notCalculated3: 17,
      //   },
      //   {
      //     student: "Э.Нандин-Эрдэнэ",
      //     register: "ме07222604",
      //     totalStudied: 91,
      //     calculated1: 0,
      //     notCalculated1: 17,
      //     calculated2: 0,
      //     notCalculated2: 38,
      //     calculated3: 0,
      //     notCalculated3: 17,
      //   },
      // ],

      finalCourses: null,
      loading: false,
      grades: null,
      renderComponent: true,
      students: null,
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
    headers3() {
      var list = [{ text: "Суралцагч", value: "name2", align: "start" }];
      if (this.finalCourses) {
        this.finalCourses.forEach((course) => {
          list.push({
            text: course.COURSE_NAME,
            value: `grades-${course.SUBJECT_AREA_ID}-${course.COURSE_CLASSIFICATION}`,
          });
        });
      }
      list.push({
        text: "Сонгон",
        value: "numberOfElectives",
      });
      return list;
    },
  },
  props: {
    selectedClassGroup: {
      type: Object,
      required: true,
    },
    classStudents: {
      type: Array,
      required: true,
    },
    lockedToCurrentLevel: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    selectedLevel(val) {
      console.log("REFRESHING", val);
      this.grades = null;
      this.$forceUpdate();
      this._setupp();
    },
  },
  methods: {
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
    getNumberOfElectives(item) {
      if (this.grades) {
        return this.grades.filter(
          (grade) =>
            grade.PERSON_ID == item.PERSON_ID &&
            grade.courseName.includes("Сонгон")
        ).length;
      }
      return null;
    },
    _setupp() {
      this.students = [];
      this.classStudents.forEach((stud) => {
        var tmp = Object.assign({}, stud);
        this.students.push(tmp);
      });

      this.students.forEach((stud) => {
        stud.name2 =
          stud.LAST_NAME[0] +
          "." +
          stud.FIRST_NAME +
          " /" +
          stud.REGISTER +
          "/";

        stud["TOTAL"] = 0;
        stud["APPROVED"] = 0;
        stud["REGISTERED"] = 0;
        stud["IN_PROGRESS"] = 0;
        stud["REJECTED"] = 0;
      });
      console.log(this.students);

      this.loading = true;

      // console.log(this.students);
      const chunkSize = 10;
      const studentChunks = [];
      for (let i = 0; i < this.students.length; i += chunkSize) {
        studentChunks.push(this.students.slice(i, i + chunkSize));
      }
      console.log(studentChunks);

      this.grades = [];
      this.finalCourses = [];
      studentChunks.forEach((chunk) => {
        fb.db
          .collectionGroup("final-scores")
          .where("academicLevel", "==", String(this.selectedLevel))
          .where(
            "PERSON_ID",
            "in",
            chunk.map((ss) => String(ss.PERSON_ID))
          )
          .get()
          .then((docs) => {
            console.log(docs.size);
            docs.forEach((doc) => {
              let grade = doc.data();
              grade.ref = doc.ref;
              grade.id = doc.id;

              if (
                this.selectedClassGroup.ACADEMIC_LEVEL != this.selectedLevel
              ) {
                if (
                  this.finalCourses.find(
                    (course) =>
                      course.SUBJECT_AREA_ID == grade.subjectAreaId &&
                      course.COURSE_CLASSIFICATION == grade.courseClassification
                  ) == undefined
                ) {
                  if (grade.courseClassificationName.includes("Заавал")) {
                    var ENROLLMENT_CATEGORY = "MANDATORY";
                  } else {
                    ENROLLMENT_CATEGORY = "ELECTIVE";
                  }

                  this.finalCourses.push({
                    COURSE_NAME: grade.courseName,
                    COURSE_CLASSIFICATION: grade.courseClassification,
                    SUBJECT_AREA_ID: grade.subjectAreaId,
                    ENROLLMENT_CATEGORY: ENROLLMENT_CATEGORY,
                  });
                  // this.headers3.push({
                  //   text: lesson.courseInfo.COURSE_NAME,
                  //   value: `grades-${lesson.courseInfo.SUBJECT_AREA_ID}-${lesson.courseInfo.COURSE_CLASSIFICATION}`,
                  // });
                }
              }

              if (
                this.selectedClassGroup.ACADEMIC_LEVEL != this.selectedLevel
              ) {
                let student = this.students.find(
                  (student) => student.PERSON_ID == grade.PERSON_ID
                );
                student["TOTAL"]++;
                student["APPROVED"]++;
              }

              this.grades.push(grade);
            });

            if (this.selectedClassGroup.ACADEMIC_LEVEL != this.selectedLevel) {
              this.finalCourses = this.finalCourses
                .sort((a, b) => a.COURSE_NAME - b.COURSE_NAME)
                .sort((a, b) => a.SUBJECT_AREA_ID - b.SUBJECT_AREA_ID)
                .sort(
                  (a, b) =>
                    b.ENROLLMENT_CATEGORY.length - a.ENROLLMENT_CATEGORY.length
                );

              var index = 1;
              this.finalCourses.forEach((lsn) => {
                lsn.index = index;

                lsn["TOTAL"] = 0;
                lsn["APPROVED"] = 0;
                lsn["REGISTERED"] = 0;
                lsn["IN_PROGRESS"] = 0;
                lsn["REJECTED"] = 0;

                index++;
              });
            }

            console.log(
              this.grades,
              "grades",
              this.headers3,
              this.finalCourses
            );
            this.grades.forEach((grade) => {
              let course = this.finalCourses.find(
                (course) =>
                  course.SUBJECT_AREA_ID == grade.subjectAreaId &&
                  course.COURSE_CLASSIFICATION == grade.courseClassification
              );
              if (course != undefined) {
                if (
                  this.selectedClassGroup.ACADEMIC_LEVEL != this.selectedLevel
                ) {
                  course["TOTAL"]++;
                  course["APPROVED"]++;
                }

                let student = this.students.find(
                  (student) => student.PERSON_ID == grade.PERSON_ID
                );
                if (student != undefined) {
                  student[
                    "grades-" +
                      course.SUBJECT_AREA_ID +
                      "-" +
                      course.COURSE_CLASSIFICATION
                  ] = grade.gradeMark;
                }
              }
            });
            console.log(this.students);
            this.$forceUpdate();
            this.forceRerender();
          });
      });

      if (this.selectedClassGroup.ACADEMIC_LEVEL == this.selectedLevel) {
        this.userData.school.ref
          .collection("lessons-" + this.userData.school.currentYear)
          .where(
            "classGroupRefs",
            "array-contains",
            this.selectedClassGroup.ref
          )
          .orderBy("courseInfo.COURSE_NAME", "asc")
          .onSnapshot((docs) => {
            this.finalCourses = [];

            docs.forEach(async (doc) => {
              let lesson = doc.data();
              lesson.ref = doc.ref;
              lesson.id = doc.id;

              if (!lesson.deleted) {
                lesson.courseInfo.ENROLLMENT_CATEGORY_NAME =
                  lesson.courseInfo.ENROLLMENT_CATEGORY_NAME.replace(
                    "судлах",
                    ""
                  );

                if (
                  this.finalCourses.find(
                    (course) =>
                      course.SUBJECT_AREA_ID ==
                        lesson.courseInfo.SUBJECT_AREA_ID &&
                      course.COURSE_CLASSIFICATION ==
                        lesson.courseInfo.COURSE_CLASSIFICATION
                  ) == undefined
                ) {
                  this.finalCourses.push(lesson.courseInfo);
                  // this.headers3.push({
                  //   text: lesson.courseInfo.COURSE_NAME,
                  //   value: `grades-${lesson.courseInfo.SUBJECT_AREA_ID}-${lesson.courseInfo.COURSE_CLASSIFICATION}`,
                  // });
                }
              }
            });

            this.finalCourses = this.finalCourses
              .sort((a, b) => a.SUBJECT_AREA_ID - b.SUBJECT_AREA_ID)
              .sort(
                (a, b) =>
                  b.ENROLLMENT_CATEGORY.length - a.ENROLLMENT_CATEGORY.length
              );
            this.loading = false;

            var index = 1;
            this.finalCourses.forEach((lsn) => {
              lsn.index = index;
              lsn["TOTAL"] = 0;
              lsn["APPROVED"] = 0;
              lsn["REGISTERED"] = 0;
              lsn["IN_PROGRESS"] = 0;
              lsn["REJECTED"] = 0;
              index++;
            });
            this.$forceUpdate();
            this.forceRerender();
          });
      }
    },
  },
  created() {
    this._setupp();
  },
};
</script>
